var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m590.52 1200c-12.008-5.6211-22.074-14.684-28.918-26.039-111.48-157.8-223.8-315-334.68-473.28-42.23-60.742-67.801-131.49-74.16-205.2-18.719-192 85.078-376.68 261.12-452.88 170.88-74.043 332.28-51.48 476.76 66.957 43.566 35.422 79.711 79.094 106.36 128.52 26.648 49.422 43.273 103.62 48.926 159.48 14.359 112.23-15.035 225.67-82.082 316.8-107.92 152-215.92 304.28-324 456.84-7.0273 12.496-17.703 22.543-30.602 28.801zm159-748.32c0.15234-39.605-15.391-77.66-43.227-105.84-27.836-28.172-65.699-44.172-105.3-44.496-39.605-0.32422-77.727 15.051-106.02 42.766-28.293 27.715-44.457 65.512-44.953 105.11-0.49609 39.605 14.719 77.793 42.312 106.21 27.59 28.414 65.316 44.738 104.91 45.406 39.996 0.48047 78.535-14.98 107.11-42.969 28.574-27.988 44.828-66.195 45.176-106.19z",
    fill: "#01447a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.3cd3a0664321cc279e841698f3c41fef.svg";
export { ForwardRef as ReactComponent };